import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import Header from "./Header";

export default function CustomerForm() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    gst_no: "",
    address: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await axios.post(`${API_BASE_URL}/api/customer`, {
        token: localStorage.getItem("authToken"),
        ...form,
      });

      if (response.data?.status) {
        setMessage("Customer saved successfully.");
        setForm({ name: "", phone: "", email: "", gst_no: "", address: "" });
      } else {
        setMessage(response.data?.message || "Unable to save customer.");
      }
    } catch (err) {
      setMessage(
        err.response?.data?.message ||
          "Error saving customer. Please try again.",
      );
      console.error("Customer save error:", err);
    }
  };

  return (
    <>
      <Header />
      <div className="du-detils">
        <div className="container">
          <div className="form total-data">
            <h2>Add Customer</h2>
            <form onSubmit={handleSubmit}>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Customer Name"
                required
              />

              <input
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Phone"
                type="tel"
              />

              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email"
                type="email"
              />

              <input
                name="gst_no"
                value={form.gst_no}
                onChange={handleChange}
                placeholder="GST Number"
              />

              <input
                name="address"
                value={form.address}
                onChange={handleChange}
                placeholder="Address"
              />

              <br />
              <button type="submit">Save Customer</button>
            </form>

            {message && (
              <div style={{ marginTop: "20px", color: "green" }}>{message}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
